import * as React from "react";
function SvgGithub(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M26 0H6a6 6 0 00-6 6v20a6 6 0 006 6h6v-4.31c-4.45 1-5.39-2.15-5.39-2.15a4.25 4.25 0 00-1.76-2.34c-1.46-1 .11-1 .11-1a3.39 3.39 0 012.45 1.65 3.39 3.39 0 004.65 1.33 3.44 3.44 0 011-2.14c-3.55-.4-7.29-1.78-7.29-7.91a6.21 6.21 0 011.65-4.29 5.67 5.67 0 01.18-4.2s1.34-.43 4.4 1.64a15.12 15.12 0 018 0c3-2.07 4.39-1.64 4.39-1.64a5.67 5.67 0 01.16 4.23 6.16 6.16 0 011.65 4.29c0 6.15-3.74 7.5-7.31 7.9A3.79 3.79 0 0120 26v6h6a6 6 0 006-6V6a6 6 0 00-6-6z"
        fill="#181616"
        fillRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGithub);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
